import { render, staticRenderFns } from "./productTraceability.vue?vue&type=template&id=653148a6&scoped=true&"
import script from "./productTraceability.vue?vue&type=script&lang=js&"
export * from "./productTraceability.vue?vue&type=script&lang=js&"
import style0 from "./productTraceability.vue?vue&type=style&index=0&id=653148a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653148a6",
  null
  
)

export default component.exports